import { render } from "./ComparisonTable.vue?vue&type=template&id=b17cfc98&scoped=true"
const script = {}

import "./ComparisonTable.vue?vue&type=style&index=0&id=b17cfc98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b17cfc98"]])

export default __exports__